<div class="homepage-wrapper flex flex-column overflow-auto">
  <div class="text-xl flex m-2">
    <img ngSrc="../../../assets/img/logo-cefla.png" alt="" height="200" width="200" />
  </div>

  <div class="flex flex-column px-7 py-6 surface-card border-round-xl w-12 md:w-9 mt-6 text-center">
    <div class="mb-4 text-3xl text-center font-semibold text-geometric-precision">{{ 'PAGES.HOMEPAGE.TITLE' | translate }}</div>

    <p>{{ 'PAGES.HOME.WELCOME_MESSAGE' | translate }}</p>

    <div class="flex justify-content-center gap-3 mt-5">
      <button class="p-button-outlined" pButton type="button" [label]="'BUTTONS.MANAGER.LOGIN' | translate" (click)="redirect()"></button>
      <button pButton type="button" [label]="'BUTTONS.MANAGER.SIGNUP' | translate" (click)="navigate('customers/signup')"></button>
    </div>
  </div>
</div>
